import React from 'react';
import {
  View,
  Text,
  StyleSheet,
  SafeAreaView,
  TouchableOpacity,
  Image,
} from 'react-native';
import { ms, s, vs } from '../../utils/responsive';
import { NavigationProp } from '@react-navigation/native';
import backIcon from '../../assets/icons/back.png';

interface UpdatePaymentScreenProps {
  navigation: NavigationProp<any>;
}

const UpdatePaymentScreen: React.FC<UpdatePaymentScreenProps> = ({ navigation }) => {
  return (
    <SafeAreaView style={styles.container}>
      <View style={styles.header}>
        <TouchableOpacity onPress={() => navigation.goBack()}>
          <Image source={backIcon} style={styles.headerIcon} />
        </TouchableOpacity>
        <Text style={styles.headerTitle}>Payment Methods</Text>
        <View style={{ width: 24 }} />
      </View>

      <View style={styles.content}>
        <Text style={styles.infoText}>
          Subscriptions are managed through the App Store. To update your payment method, go to Settings → Apple ID → Subscriptions on your device.
        </Text>

        <TouchableOpacity style={styles.proceedButton} onPress={() => navigation.navigate('SubscriptionManagement')}>
          <Text style={styles.proceedButtonText}>MANAGE SUBSCRIPTION</Text>
        </TouchableOpacity>
      </View>
    </SafeAreaView>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#F3F6F8',
  },
  header: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingHorizontal: ms(20),
    paddingVertical: ms(20),
    marginTop: ms(5),
    backgroundColor: '#F3F6F8',
  },
  headerTitle: {
    fontSize: ms(18, 0.3),
    fontWeight: 'bold',
    color: '#333',
  },
  headerIcon: {
    width: s(24),
    height: s(24),
    tintColor: '#333',
  },
  content: {
    flex: 1,
    paddingHorizontal: ms(20),
    paddingTop: ms(20),
  },
  infoText: {
    fontSize: ms(16, 0.3),
    color: '#666',
    lineHeight: ms(24, 0.3),
    textAlign: 'center',
    marginBottom: ms(30),
  },
  proceedButton: {
    backgroundColor: '#2C4364',
    borderRadius: ms(25),
    padding: ms(15),
    alignItems: 'center',
  },
  proceedButtonText: {
    color: '#fff',
    fontWeight: 'bold',
    fontSize: ms(18, 0.3),
  },
});

export default UpdatePaymentScreen;
